import {
  IMappedTeacherScheduleWithoutDate,
  ITeacherSchedule,
  mappedTeacherScheduleWithoutDate,
} from 'entities/types';
import {
  dicsiplTypeToPrettyFormat,
  isNeedToShowByWeekParityAndDateTime,
  locationToPrettyFormat,
  makeHash,
  WeekParity,
} from 'shared/lib';

export const mapTeacherScheduleWithoutDate = (
  data: ITeacherSchedule[],
): mappedTeacherScheduleWithoutDate => {
  const scheduleWeekDays = [1, 2, 3, 4, 5, 6];
  const scheduleMatrix: mappedTeacherScheduleWithoutDate = [];

  scheduleWeekDays.forEach((dayNum, index) => {
    if (!scheduleMatrix[index]) {
      scheduleMatrix[index] = [];
    }

    const schedule = data.filter((schedule) => +schedule.daynum === dayNum);

    let mapped: IMappedTeacherScheduleWithoutDate;

    if (schedule.length) {
      schedule.forEach((item, i) => {
        mapped = {
          isEven: isNeedToShowByWeekParityAndDateTime({
            weekParity: WeekParity.Even,
            dayDate: item.daydate,
          }),
          dayDate: item.daydate,
          dayNum: item.daynum ? +item.daynum : index,
          disciplName: item.disciplname,
          disciplType: dicsiplTypeToPrettyFormat(item.discipltype),
          disciplTime: item.daytime,
          location: locationToPrettyFormat({
            buildNum: item.building,
            audNum: item.auditory,
          }),
          groupsTags: item.group_list,
          teacher: item.prepodfio,
          key: makeHash(
            i.toString() +
              item.disciplname +
              item.daytime +
              item.daynName +
              item.prepodId +
              item.group +
              item.numDisciplGuide,
          ),
          group: item.group,
        };
        scheduleMatrix[index].push(mapped);
      });
    }
  });
  return scheduleMatrix;
};
